// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ForbiddenView_wrap__2yEAt","content":"ForbiddenView_content__1iR9_"};